export default "__VITE_ASSET__DosEAnSK__"